// Plain API helpers for survey results + image upload.
// These are thin fetch wrappers with no shared client state, so they don't need a
// state library (Redux holds the survey condition; these just talk to the backend).

// Defaults to "" so the CRA dev proxy handles same-origin /api requests locally.
// Override with REACT_APP_API_BASE for non-proxied deployments.
const API_BASE = process.env.REACT_APP_API_BASE || ""

export async function createResults(newResults) {
    try {
        const res = await fetch(API_BASE + "/api/survey", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newResults),
        })
        if (!res.ok) {
            return { success: false, message: "Server responded with status " + res.status }
        }
        return { success: true, message: "Results created!" }
    } catch (error) {
        console.log("Error in creating results: ", error.message)
        return { success: false, message: "Create results failed with error: " + error.message }
    }
}

export async function uploadImage(image, imageName) {
    try {
        const res = await fetch(API_BASE + "/api/survey/uploadImage", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ image, imageName }),
        })
        if (!res.ok) {
            return { success: false, message: "Server responded with status " + res.status }
        }
        return { success: true, message: "Image uploaded!" }
    } catch (error) {
        console.log("Error in saving image: ", error.message)
        return { success: false, message: "Upload failed with error: " + error.message }
    }
}
